import isValidDomain from "is-valid-domain";

function validateDomain() {
  return {
    restrict: "A",
    require: "ngModel",
    scope: {
      validateDomain: "=",
    },
    link($scope, $element, $attrs, $ctrl) {
      $ctrl.$validators.validateDomain = (modelValue, viewValue) =>
        isValidDomain(modelValue);
    },
  };
}

export default validateDomain;
